import classNames from 'classnames';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {
	VideosAssignmentContext,
	IVideosAssignmentContext,
	TActiveItemToDisplay,
} from '../../../../../videosAssignmentState/videosAssignmentContext';
import React, { useContext } from 'react';
import style from './SectionsSwitcher.module.scss';

const SectionsSwitcher = () => {
	const {
		changeActiveItemToDisplay,
		activeItemToDisplay,
		allCustomers,
		IDsSelectedCustomers,
		IDsSelectedRestaurants,
	} = useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	const buttonClasses = (itemName: TActiveItemToDisplay) =>
		classNames(style.button, { [style.withoutHover]: activeItemToDisplay === itemName });

	const customersButtonActiveState = activeItemToDisplay === 'customers' || !allCustomers.length;
	const restaurantsButtonActiveState =
		activeItemToDisplay === 'restaurants' || !Object.keys(IDsSelectedCustomers).length;
	const gamesButtonActiveState = activeItemToDisplay === 'videos' || !Object.keys(IDsSelectedRestaurants).length;
	return (
		<div data-test="SectionsSwitcher" className={style.container}>
			<Button
				className={buttonClasses('customers')}
				theme={customersButtonActiveState ? 'primaryBlue' : 'secondary'}
				onClick={() => changeActiveItemToDisplay('customers')}
				disabled={!allCustomers.length}>
				<Text translationNameSpace="listing" translationKey="customersLabel" asFragment={true} />
			</Button>
			<Button
				className={buttonClasses('restaurants')}
				theme={restaurantsButtonActiveState ? 'primaryBlue' : 'secondary'}
				onClick={() => changeActiveItemToDisplay('restaurants')}
				disabled={!Object.keys(IDsSelectedCustomers).length}>
				<Text translationNameSpace="listing" translationKey="restaurantsLabel" asFragment={true} />
			</Button>
			<Button
				className={buttonClasses('videos')}
				theme={gamesButtonActiveState ? 'primaryBlue' : 'secondary'}
				onClick={() => changeActiveItemToDisplay('videos')}
				disabled={!Object.keys(IDsSelectedRestaurants).length}>
				<Text translationNameSpace="listing" translationKey="videosLabel" asFragment={true} />
			</Button>
		</div>
	);
};

export default SectionsSwitcher;
